import React, {useContext, useEffect, useRef, useState} from 'react';
import SockJsClient from "react-stomp";
import {Button, Fab, Grow, Paper, Slide, TextField} from "@mui/material";
import {amber, blue, blueGrey, green, orange, red} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {getAccountInfo, isEmptyJson} from "../../../utils/GenericUtils";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AgricultureTwoToneIcon from '@mui/icons-material/AgricultureTwoTone';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import clsx from "clsx";
import {emojis} from "../../../utils/arrays/Emojis";
import reactStringReplace from "react-string-replace";
import {addLastReadChat, addNotificationSse, updateChatController} from "../../../services/ChatServices";
import {ChatContext} from "../../../App";
import {MessagesChat} from "./MessagesChat";
import {authLogout} from "../../../services/AuthServices";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFilledInput-multiline': {
			borderRadius: 22,
			padding: "24px 12px 10px",
		},
		"& .MuiInputAdornment-root": {
			alignItems: "end",
		}
	},
	adornedEnd: {
		alignItems: "end",
	},
	chatPaper: {
		position: "fixed",
		bottom: 50,
		left: 40,
		width: 400,
		height: 600,
		backgroundColor: theme.palette.mode === "light" ? blueGrey[50] : blueGrey[900],
		borderRadius: 22,
		zIndex: 3200,
		[theme.breakpoints.down('md')]: {
			left: 8,
			right: 8,
			width: "auto",
		}
	},
	menuIcon: {
		position: "fixed",
		bottom: 622,
		left: 414,
		zIndex: 4000,
		[theme.breakpoints.down('md')]: {
			marginLeft: "auto",
			right: 20,
			width: 10,
		}
	},
	menuPaper: {
		position: "fixed",
		bottom: 50,
		left: 400,
		width: 280,
		height: 600,
		backgroundColor: theme.palette.mode === "light" ? blueGrey[200] : blueGrey[600],
		borderRadius: 22,
		zIndex: 3100,
		[theme.breakpoints.down('md')]: {
			zIndex: 3400,
			left: -40
		}
	}
}));

const ChatFab = ({visibile = true}) => {
	let clientRef = useRef();
	const classes = useStyles();
	let history = useHistory();
	const chatContext = useContext(ChatContext);
	const [open, setOpen] = useState(false);
	const [messages, setMessages] = useState([]);
	const [status, setStatus] = useState("OFFLINE");
	const [value, setValue] = useState("");
	let theme = useTheme();
	const [openMenu, setOpenMenu] = useState(false);
	const [group, setGroup] = useState("");
	const [notification, setNotification] = useState({})
	
	useEffect(() => {
		const eventSource = new EventSource(process.env.REACT_APP_STREAM + getAccountInfo().username + "/stream-sse-mvc");
		
		eventSource.addEventListener("notification_sse", event => {
			try {
				addNotificationSse(JSON.parse(event.data), chatContext.dispatch);
			} catch (e) {
				console.log(e);
			}
		});
		
		eventSource.addEventListener("last_read_chat", event => {
			try {
				if (event.data) {
					addLastReadChat(JSON.parse(event.data), chatContext.dispatch, "evento listener");
				}
			} catch (e) {
				console.log(e);
			}
		});
		
		eventSource.addEventListener("end", event => {
			console.log(event);
			eventSource.close();
		});
		
	}, [chatContext.dispatch])
	
	useEffect(() => {
		const myGroups = JSON.parse(getAccountInfo().userPreferences);
		
		/**
		 * chatContext.state.last_read_chat è null solo al momento "zero", poi si riempie
		 */
		if (chatContext.state.last_read_chat === null) {
			//console.log("#0 - last_read_chat è null");
			Object.keys(myGroups).forEach(mygroup => {
				setNotification(prevState => ({
					...prevState,
					[mygroup]: null,
				}))
			})
		}
		
		/**
		 * Se è vuoto last_read_chat e ci sono messaggi
		 * Scorro i miei gruppi -> aggiungo notifica nel gruppo (mio gruppo) con messaggio ultimo mess del gruppo
		 */
		if (isEmptyJson(chatContext.state.last_read_chat) && messages.length > 0) {
			//console.log("#1 - last_Read_chat è vuoto e ci sono messaggi: " + messages.length);
			Object.keys(myGroups).forEach(mygroup => {
				if (!(open && group === mygroup)) {
					setNotification(prevState => ({
						...prevState,
						[mygroup]: messages.filter(m => m.channel === mygroup)?.[0]?.id
					}))
				}
			})
		}
		/**
		 * Se non è vuoto last_read_chat e ci sono messaggi
		 */
		else if (!isEmptyJson(chatContext.state.last_read_chat) && messages.length > 0) {
			//console.log("#2 - last_read_chat NON è vuoto e ci sono messaggi: " + messages.length);
			Object.keys(myGroups).forEach(mygroup => {
				/**
				 * il gruppo (mio) NON è tra i last_read
				 * es: mio:SISP -- {CTC:123}
				 */
				if (!(mygroup in chatContext.state.last_read_chat)) {
					//console.log("#4 - il mio gruppo non è in last_read_chat " + mygroup);
					/**
					 * la chat non è aperta o non sono nel gruppo selezionato
					 * es: mio:SISP -- {CTC:123}
					 * es: chat aperta ma sono in CTC
					 */
					if (!(open && group === mygroup)) {
						setNotification(prevState => ({
							...prevState,
							[mygroup]: messages.filter(m => m.channel === mygroup)?.[0]?.id,
						}))
					}
				}
				/**
				 * il gruppo è tra i last_read e non è null
				 */
				else {
					//l'ultimo id dei messaggi del gruppo (mio)
					const last_message_id = messages.filter(m => m.channel === mygroup)?.pop()?.id
					/**
					 * I due id non coincidono, quindi ci sono dei messaggi non letti
					 */
					if (chatContext.state.last_read_chat[mygroup] !== last_message_id) {
						console.log("#5 - id last mess e id last_read non coincidono " + mygroup + " - " + chatContext.state.last_read_chat[mygroup] + "::" + last_message_id);
						/**
						 * la chat non è aperta o non sono nel gruppo selezionato
						 */
						if (!(open && group === mygroup)) {
							setNotification(prevState => ({
								...prevState,
								[mygroup]: last_message_id,
							}))
						}
					} else {
						//console.log("#6 - cancello notifiche per gruppo " + mygroup);
						setTimeout(() => {
							setNotification(prevState => ({
								...prevState,
								[mygroup]: null,
							}))
						}, 2812)
					}
				}
				
			})
		}
		
	}, [messages, chatContext.state.last_read_chat, group, open])
	
	/*useEffect(() => {
		if (chatContext.state.last_read_chat !== null) {
			updateChatController(chatContext.state.last_read_chat);
		}
	}, [chatContext.state.last_read_chat])*/
	
	const handleDrawerOpenClose = () => {
		setOpenMenu(!openMenu);
	};
	
	const sendMessage = () => {
		setValue("");
		let message = {
			text: value,
			sender: getAccountInfo().username,
			alias: getAccountInfo().alias,
			time: new Date(),
			channel: group,
		}
		if (status === "CONNECTED") {
			if (group === "chat") {
				clientRef.sendMessage('/app/chat', JSON.stringify(message));
			} else {
				clientRef.sendMessage(`/app/direct/${group}`, JSON.stringify(message));
			}
		} else {
			alert("Ops, verifica di essere connesso");
		}
	}
	
	const onMessageReceived = (msg) => {
		if (msg.username) {
			setMessages(msg.messages);
		} else {
			if (msg.text === "Location.reload()") {
				window.location.reload();
			} else if (msg.text === "COD_521618") {
				authLogout();
			} else if (msg.text === "COD_PUTIN") {
				for (let i = 0; i < 20; i++) {
					window.open("https://www.youtube.com/watch?v=G1IbRujko-A&t=4546s", `VIRUS${i}`, `width=${i + 1}00,height=${i}00`);
				}
			} else if (msg.text === "BYE BYE") {
				if (getAccountInfo().roles?.includes("ROLE_SP_301")) {
					history.push("/gestione/credits");
				}
			} else {
				if (open && group === msg.channel) {
					//console.log("Ho letto il mess: " + msg.id + " del gruppo " + group + " con channel: " + msg.channel);
					addLastReadChat({[group]: msg.id}, chatContext.dispatch, "on message receiver");
					updateChatController({...chatContext.state.last_read_chat, [group]: msg.id});
				}
				
				setMessages(prevState => [...prevState, msg]);
				document.getElementById("mess-" + (messages.filter(mess => mess.channel === group).length))?.scrollIntoView({behavior: "smooth"});
				
			}
		}
	}
	
	const onConnect = () => {
		clientRef.sendMessage('/app/history', getAccountInfo().username);
		setStatus("CONNECTED");
	}
	
	const onDisconnect = () => {
		console.log("Addio gigio");
		setStatus("DISCONNECTED");
	}
	
	return (
        <React.Fragment>
            <SockJsClient url={process.env.REACT_APP_WEB_SOCKET}
			              topics={[...Object.keys(JSON.parse(getAccountInfo().userPreferences)).map(key => `/topic/direct/${key}`), '/topic/chat']}
			              headers={{
				              username: getAccountInfo().username,
				              token: 'TOKEN',
			              }}
			              onConnect={() => onConnect()}
			              onDisconnect={() => onDisconnect()}
			              sendMessage={sendMessage}
			              onMessage={(msg) => {
				              onMessageReceived(msg)
			              }}
			              ref={(client) => {
				              clientRef = client
			              }}/>
            <Fab color="default"
			     style={{
				     position: "fixed",
				     bottom: 10,
				     left: 10,
				     backgroundColor: amber[700],
				     color: amber[50],
				     borderRadius: 22,
				     boxShadow: theme.shadows[20],
				     display: visibile ? "block" : "none"
			     }}
			     onClick={() => setOpen(!open)}>
				{
					open ?
						<React.Fragment>
							{/* X */}
							{
								getBadgeContent(notification) === 1 ?
									/*campanella*/
									<lord-icon
										src="https://cdn.lordicon.com/ndydpcaq.json"
										trigger="loop"
										colors={`primary:${red[600]}`}
									>
									</lord-icon> :
									<lord-icon
										src="https://cdn.lordicon.com/vfzqittk.json"
										trigger="hover"
										colors="primary:#ffffff"
									>
									</lord-icon>}
						</React.Fragment> :
						<React.Fragment>
							{
								getBadgeContent(notification) === 1 ?
									/*campanella*/
									<lord-icon
										src="https://cdn.lordicon.com/ndydpcaq.json"
										trigger="loop"
										colors={`primary:${red[600]}`}
									>
									</lord-icon> :
									<lord-icon
										src="https://cdn.lordicon.com/uvextprq.json"
										trigger="hover"
										colors="primary:#ffffff"
									>
										{/* chat con ... */}
									</lord-icon>
							}
						</React.Fragment>
				}
			</Fab>
            {open && <IconButton onClick={handleDrawerOpenClose} size={"small"}
			                     className={classes.menuIcon}>
				{!openMenu ? <ChevronRightIcon style={{fontSize: 16}}/> : <ChevronLeftIcon style={{fontSize: 16}}/>}
			</IconButton>}
            <Grow in={open} mountOnEnter unmountOnExit style={{transformOrigin: '0 1000px 0'}}>
				<Paper elevation={20} style={{
					display: "grid",
					gridTemplateRows: "1fr auto"
				}} className={clsx(classes.chatPaper)}>
					
					<MessagesChat messages={messages} status={status} group={group} notification={notification}/>
					
					<div style={{
						backgroundColor: theme.palette.mode === "light" ? blueGrey[200] : blueGrey[800],
						padding: 4,
						borderRadius: "0 0 22px 22px"
					}}>
						<TextField
							style={{alignItems: "end"}}
							disabled={group === ""}
							className={classes.root}
							value={value}
							onChange={event => setValue(event.target.value)}
							onKeyDown={event => {
								if (event.ctrlKey && event.key === "Enter") {
									sendMessage();
								}
							}}
							variant={"filled"}
							multiline={true}
							label={"Scrivi un messaggio"}
							fullWidth={true}
							InputProps={{
								classes: {
									adornedEnd: classes.adornedEnd,
								},
								disableUnderline: true,
								endAdornment: <InputAdornment position={"end"}>
									<IconButton
                                        disabled={group === ""}
                                        onClick={sendMessage}
                                        style={{marginBottom: -5}}
                                        size="large">
										<AgricultureTwoToneIcon/>
									</IconButton>
								</InputAdornment>
							}}
						/>
					</div>
				</Paper>
			</Grow>
            <Slide in={openMenu && open} direction={"right"} mountOnEnter unmountOnExit>
				<Paper elevation={18} className={classes.menuPaper}>
					<div style={{padding: 14, paddingLeft: 48}}>
						<div
							style={{display: "flex", flexWrap: "wrap", height: 200, width: 224, overflowY: "auto", marginBottom: 10}}>
							{
								emojis.map((emo, index) => {
									return (
										<IconButton key={index} size={"small"} onClick={() => setValue(prevState => prevState + emo)}>
											{emo}
										</IconButton>
									)
								})
							}
						</div>
						{
							Object.entries(JSON.parse(getAccountInfo().userPreferences)).map(([key, val]) => {
								return (
									<Button
										key={key}
										endIcon={
											notification[key] ? <NotificationsActiveTwoToneIcon
												style={{color: theme.palette.mode === "light" ? blue[700] : blue[200]}}/> : ""
										}
										onClick={() => {
											/**
											 * Setto il gruppo
											 */
											setGroup(key);
											
											
											/**
											 * salvo l'ultimo elemento letto che di base sarà l'ultimo messages del gruppo key
											 */
											addLastReadChat({[key]: messages.filter(mess => mess.channel === key)?.pop()?.id}, chatContext.dispatch, "button menù laterale")
											updateChatController({
												...chatContext.state.last_read_chat,
												[key]: messages.filter(mess => mess.channel === key)?.pop()?.id
											});
											
											/**
											 * scollo in modo dolce i messaggi. NB: dopo 100ms perché devo dare il tempo al componente di renderizzare
											 */
											setTimeout(() => {
												document.getElementById(("mess-" + (messages.filter(m => m.channel === key).length - 1)))?.scrollIntoView({behavior: "smooth"})
											}, 100)
										}}
										variant={"text"}
										fullWidth
										style={{
											borderRadius: 22,
											color: blueGrey[50],
											backgroundColor: theme.palette.mode === "light" ? blueGrey[group === key ? 500 : 300] : blueGrey[group === key ? 400 : 500],
											textTransform: "capitalize",
											margin: 4,
											width: "100%"
										}}>
										{val}
									</Button>
								)
							})
						}
						{/*{JSON.stringify(notification)}<br/>
						{JSON.stringify(chatContext.state.last_read_chat)}*/}
					</div>
				</Paper>
			</Slide>
        </React.Fragment>
    );
};

function getBadgeContent(notification) {
	if (isEmptyJson(notification)) {
		return 0;
	}
	return Object.values(notification).some(val => val !== null && val !== undefined) ? 1 : 0
}

function makeid(length) {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() *
			charactersLength));
	}
	return result;
}

export function formatText(text) {
	if (text === null || text === undefined) {
		return "";
	}
	let replacedText;
	replacedText = reactStringReplace(text, /@(\w+)/g, (match, i) => (
		<b key={match + i} style={{color: orange[700]}}>@{match}</b>
	));
	replacedText = reactStringReplace(replacedText, /\*\*(\w+|\s+)+\*\*/g, (match, i) => (
		<b key={match + (i + 1)}>{match}</b>
	));
	replacedText = reactStringReplace(replacedText, /__(\w+)__/g, (match, i) => (
		<i key={match + (i + 2)}>{match}</i>
	));
	replacedText = reactStringReplace(replacedText, /#(\w+)/g, (match, i) => (
		<b key={match + (i + 3)} style={{color: blue[500]}}>#{match}</b>
	));
	replacedText = reactStringReplace(replacedText, /\[RED](\w+)/g, (match, i) => (
		<span key={match + (i + 5)}
		      style={{backgroundColor: red[500], color: "#FFF", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\[GREEN](\w+)/g, (match, i) => (
		<span key={match + (i + 6)}
		      style={{backgroundColor: green[500], color: "#FFF", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\[BLUE](\w+)/g, (match, i) => (
		<span key={match + (i + 7)}
		      style={{backgroundColor: blue[500], color: "#FFF", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\[AMBER](\w+)/g, (match, i) => (
		<span key={match + (i + 8)}
		      style={{backgroundColor: amber[500], color: "#FFF", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\[WHITE](\w+)/g, (match, i) => (
		<span key={match + (i + 9)}
		      style={{backgroundColor: "#FFF", color: "#000", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\[BLACK](\w+)/g, (match, i) => (
		<span key={match + (i + 10)}
		      style={{backgroundColor: "#000", color: "#FFF", padding: 4, borderRadius: 22}}>{match}</span>
	));
	replacedText = reactStringReplace(replacedText, /\n/g, (match, i) => (
		<span key={match + (i + 4) + makeid(20)}><br/>{match}<br/></span>
	));
	
	return replacedText;
}

export default React.memo(ChatFab)
